import React from 'react';
import { Box, Typography, Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const StandardsLibrary: React.FC = () => {
  return (
    <Box sx={{ height: 'calc(100vh - 64px)', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ px: 3, py: 2, borderBottom: '1px solid #e0e0e0', backgroundColor: '#fff' }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link component={RouterLink} to="/" color="inherit">
            Home
          </Link>
          <Typography color="text.primary">Standards Library</Typography>
        </Breadcrumbs>
        <Typography variant="h5" sx={{ mt: 1, color: 'primary.main', fontWeight: 600 }}>
          Technical Publications Standards Library
        </Typography>
      </Box>
      <Box sx={{ flex: 1 }}>
        <iframe
          src="https://technical-publications.vercel.app"
          title="Technical Publications Standards Library"
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
          }}
        />
      </Box>
    </Box>
  );
};

export default StandardsLibrary;
